import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import ROUTE_PATHS from '@/consts/route/routePaths';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import uwmService from '@/services/uwm/uwmService';
import {selectLoyaltyJourneys} from '@/state/selectors/consumerLoyalty';
import HomePageLayout from '@/views/Home/HomePageLayout';
import UwmModule from '@/views/UwmModule/UwmModule';

const LoyaltyDetailsPage = () => {
    const isDesktopLayout = useIsDesktopLayout();

    return isDesktopLayout ? (
        <HomePageLayout activePath={ROUTE_PATHS.HOME_PAGE}>
            <UwmLoyaltyModule />
        </HomePageLayout>
    ) : (
        <UwmLoyaltyModule />
    );
};

const UwmLoyaltyModule = () => {
    const loyaltyJourneys = useSelector(selectLoyaltyJourneys);
    const isModuleLoadedRef = useRef(false);

    const onModuleLoaded = () => {
        isModuleLoadedRef.current = true;
        uwmService.postLoyaltyInitMessage();
        uwmService.postMarketLocaleInitMessage();
    };

    useEffect(() => {
        if (isModuleLoadedRef.current) {
            uwmService.postLoyaltyRefreshMessage();
        }
    }, [loyaltyJourneys]);

    return <UwmModule onModuleLoaded={onModuleLoaded} src={process.env.REACT_APP_UWM_LOYALTY_SRC} />;
};

export default LoyaltyDetailsPage;
